import http from '@/utils/http';
import SteamSalesAdapter from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/SteamSales/_config/steamSalesAdapter';

class ConsoleDataAdapter {
  static convertParams(payload: Record<string, any> = {}) {
    const {
      date_type,
      period,
      start_date,
      end_date,
      segment,
      metric_condition,
      entity_type,
      gameId,
      unified_ids,
      edition_id,
    } = payload;

    const gameIdValue = unified_ids?.[0] || edition_id || gameId;
    const metric = segment;

    if (!gameIdValue) {
      throw new Error('Missing required parameter: gameId');
    }
    if (!metric) {
      throw new Error('Missing required parameter: segment');
    }
    if (!entity_type) {
      throw new Error('Missing required parameter: entity_type');
    }

    return {
      ids: [gameIdValue],
      granularity: period || date_type || 'monthly',
      start_date: start_date || '',
      end_date: end_date || '',
      source_metrics: { alinea: [metric] },
      entity_type: Array.isArray(entity_type) ? entity_type[0] : entity_type,
      markets: ['global'],
      metric_condition: metric_condition || {},
      segments: ['All'],
      b_true_data: true,
      b_group_by_date: true,
      b_growth_ratio: true,
      b_sum_avg_show: true,
      b_group_by_market: false,
      b_group_by_region: false,
      b_group_by_platform: false,
      b_group_by_segment: false,
      start_release_time: 0,
      end_release_time: 0,
      adjust_metric: payload?.adjust_metric ?? true,
    };
  }

  static convertMarketParams(payload: Record<string, any> = {}) {
    const convertedParams = this.convertParams(payload);
    return {
      ...convertedParams,
      start_date: '',
      end_date: '',
      b_group_by_date: false,
      b_group_by_market: true,
    };
  }

  static async fetchTrend(payload: Record<string, any>) {
    const convertedParams = this.convertParams(payload);
    const response = await http({
      url: '/api/v1/intelligence_pc/compare/pcConsoleMetricData',
      method: 'post',
      data: convertedParams,
      rawData: true,
    });
    return SteamSalesAdapter.convertToSalesTrendFormat(response);
  }

  static async fetchMarket(payload: Record<string, any>) {
    const convertedParams = this.convertMarketParams(payload);
    const response = await http({
      url: '/api/v1/intelligence_pc/compare/pcConsoleMetricData',
      method: 'post',
      data: convertedParams,
      rawData: true,
    });
    return SteamSalesAdapter.convertToSalesMarketFormat(response);
  }
}

export default ConsoleDataAdapter;
